module.exports = __webpack_public_path__ + "img/schwab.04afe7f4.png";